import React, { useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import "./EnrollCouple.scss";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

const EnrollCouple = () => {
  const [name, setName] = useState("");
  const [showEnroll, setShowEnroll] = useState(false);
  const [data, setData] = useState([]);
  const [partnerId, setPartnerId] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const lock = useRef(false);
  const { option2 } = useParams();
  const navigate = useNavigate();

  const searchStudent = async () => {
    if (lock.current) return;
    lock.current=true; setBusy(true); setError(""); setPartnerId(""); setData([]); setShowEnroll(false);
    try {
    const login_cookie = localStorage.getItem("session_user_login_cookie");
    const login_user_id = localStorage.getItem("session_user_id");
    const login_action_type = localStorage.getItem("session_user_type");

    await axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/?login_cookie=${login_cookie}&login_user_id=${login_user_id}&login_action_type=${login_action_type}&f=getFilteredStudent&student_name=${encodeURIComponent(name.trim())}&status=1`
      )
      .then((resp) => {
        if (resp.data.status === true) {
          const rows=Array.isArray(resp.data.student)?resp.data.student:Object.values(resp.data.student||{});
          const eligible=rows.filter(row=>String(row.student_id)!==login_user_id);
          setData(eligible);
          if (eligible.length === 0) {
            setShowEnroll(false);
            setError("Keine andere Person gefunden. Bitte nach deinem Partner suchen.");
            return;
          }
          setShowEnroll(true);
          toast(
            "Student found successfully! Please submit to enroll as couple"
          );
        }
        if (resp.data.status === false) {
          toast("Student not found, Please search again!");
        }
      });
    } catch { setError("Die Suche ist fehlgeschlagen. Bitte erneut versuchen."); }
    finally { lock.current=false; setBusy(false); }
  };

  const enrollStudent = async () => {
    if (lock.current) return;
    if (!partnerId || !data.some(row=>String(row.student_id)===partnerId)) { setError("Bitte deinen Partner eindeutig auswählen."); return; }
    lock.current=true; setBusy(true); setError("");
    try {
    const params = new URLSearchParams(option2);
    const course_id = params.get("course_id");
    const course_title = params.get("course_title");

    const login_cookie = localStorage.getItem("session_user_login_cookie");
    const login_user_id = localStorage.getItem("session_user_id");
    const login_action_type = localStorage.getItem("session_user_type");

    await axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/?login_cookie=${login_cookie}&login_user_id=${login_user_id}&login_action_type=${login_action_type}&f=enrollCouplenew&school_id=${localStorage.getItem(
          "session_school_id"
        )}&level_id=${localStorage.getItem(
          "session_user_level_id"
        )}&course_id=${course_id}&user_id=${localStorage.getItem(
          "session_user_id"
        )}&course_title=${encodeURIComponent(course_title||"")}&partner_id=${partnerId}&status=1`
      )
      .then((resp) => {
        if (resp.data.status === true) {
          toast("ENROLLED SUCCESSFULLY");
          setTimeout(() => {
            navigate(`/Home/course/applyCourse/${course_id}`);
          }, 3000);
        }
        else setError(resp.data.message || "Die Paarbuchung wurde nicht bestätigt.");
      });
    } catch { setError("Die Verbindung ist fehlgeschlagen. Die Buchung wurde nicht bestätigt."); }
    finally { lock.current=false; setBusy(false); }
  };

  return (
    <div className="apply_course_search_section">
      <ToastContainer />
      <div className="container-fluid">
        <div className="user_detail">
          <div className="apply_course_title">
            <h2>Apply Course</h2>
          </div>
        </div>
        <div className="apply_course_search">
          <form className="row" onSubmit={event=>event.preventDefault()}>
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <input
                type="text"
                className="form-control"
                id="inputFirstname"
                placeholder="Search Student Name"
                value={name}
                disabled={busy}
                onChange={(e) => {
                  setName(e.target.value);
                  setShowEnroll(false); setPartnerId(""); setData([]); setError("");
                }}
              />
            </div>
            <div className="col-12">
              {showEnroll && <><label htmlFor="partner-choice">Partner auswählen</label><select id="partner-choice" className="form-control" value={partnerId} disabled={busy} onChange={event=>setPartnerId(event.target.value)}><option value="">Bitte auswählen</option>{data.map(row=><option key={row.student_id} value={String(row.student_id)}>{row.student_first_name} {row.student_last_name} (#{row.student_id})</option>)}</select></>}
              {error && <p role="alert">{error}</p>}
              {showEnroll ? (
                <Link
                  className="btn btn_primary"
                  href="#"
                  onClick={() => { if (!busy) enrollStudent(); }}
                >
                  Paarbuchung bestätigen
                </Link>
              ) : (
                <Link
                  className="btn btn_primary"
                  href="#"
                  onClick={() => { if (!busy) searchStudent(); }}
                >
                  Search
                </Link>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EnrollCouple;
